import React from "react";
import YouTube from "react-youtube";

function ProjectCards(props) {
  return (
    <div className="project-card-view p-3 ">
      <YouTube
        videoId={props.imgPath}
        opts={{
          width: "100%",
          height: "400px",
        }}
      />
      <h2>{props.title}</h2>
      <div style={{ textAlign: "justify" }}>{props.description}</div>
    </div>
  );
}
export default ProjectCards;
